<template>
  <div class="sign">
    <div class="sign-item">
      <div class="item-top">
        <div>
          <p>{{ $route.query.isNoScan === "true" ? "不发箱号" : "待发箱号" }}</p>
        </div>
      </div>
      <template v-if="list.length">
        <ul class="bale-sku">
          <li v-for="(item, index) in list" :key="index">
            <div>
              <div class="sign-list">
                <p>
                  <span>{{item.customerBox }}</span><span v-if="isNoScan == 'false'">{{item.isSend?'(已发)':'' }}</span>
                  <a
                    v-if="isNoScan == 'true'"
                    style="float: right; margin-right: 10px; color: blue"
                    @click="delBox(item.tfBoxInfoID,item.customerBox)"
                    >删除</a>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <van-empty image="search" description="暂无数据" />
      </template>
    </div>

    <div class="submit-box">
      <button class="submit-btn" @click="toBack()">返回上一页</button>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  Dialog,
} from "vant";
import {getBoxList,DeleteScanBoxInfo} from "@/api/mobile/jy-outbound_api";
import { mapState } from "vuex";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      list: [],
      loading: false,
      isNotScan:false,
    };
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  methods: {
    init() {
      this.getList();
    },

    getList() {
      const { tfOutboundID, isNoScan } = this.$route.query;
      this.isNoScan=isNoScan;
      const data = {
        tfOutboundID,
        isNoScan,
      };

      getBoxList(data).then((res) => {
        if (res.status === 200) {
          const { response } = res;

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toBack() {
      this.$router.go(-1);
    },
    delBox(id, boxNo) {
      Dialog.confirm({
        title: "箱号【" + boxNo + "】",
        message: "确认删除？",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          Toast.loading({
            message: "删除中...",
            forbidClick: true,
            overlay: true,
            duration: 0,
          });

          DeleteScanBoxInfo({ tfBoxInfoID: id }).then((res) => {
            Toast.clear();
            if (res.status === 200) {
              this.getList();
            } else {
              Toast.fail(res.msg);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}

::v-deep .van-tabs--card {
  border-bottom: 1px solid #ccc;
}
.sign-item {
  margin-bottom: 95px;
}
.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}
.sign-item li {
  font-size: 14px;
}
.item-top {
  display: flex;
  // border-bottom: 1px solid #ccc;
  padding: 5px 0;
  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
.sign-list {
  text-align: center;
}
p {
  margin: 10px 0 !important;
}
.submit-box .submit-btn {
  background-color: #dedede;
  color: #3e3e3e;
}
</style>